import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { SkipNavContent, TYPES } from 'sarsaparilla';
import { STATE_READY } from '../../../../ui-lottery/src/utils/async_utils';
import { fetchAsset } from '../../actions/asset';
import { getAsset } from '../../reducers/asset';
import { getState } from '../../reducers';
import TextDisplay from '../../components/StewardAssetDisplay/TextDisplay';
import LoadingWrapper from '../../../../ui-lottery/src/components/LoadingWrapper';

import styles from './StewardAssetDisplayPage.scss';

const propTypes = {
  match: TYPES.MATCH,
  asset: PropTypes.shape({}),
  states: PropTypes.objectOf(PropTypes.number),
  fetchData: PropTypes.func.isRequired
};

const defaultProps = {
  asset: {}
};

const FACILITY_URL = 'facility';

const facilityDisplayFields = [
  {
    label: 'Facility Name',
    field: 'name'
  },
  {
    label: 'Facility ID',
    field: 'id'
  },
  {
    label: 'Email',
    field: 'email'
  },
  {
    label: 'Fee Description',
    field: 'feeDescription'
  },
  {
    label: 'Legacy ID',
    field: 'legacyId'
  },
  {
    label: 'Legacy ID Organization',
    field: 'legacyIdOrg'
  },
  {
    label: 'Latitude',
    field: 'latitude'
  },
  {
    label: 'Longitude',
    field: 'longitude'
  },
  {
    label: 'Phone',
    field: 'phone'
  },
  {
    label: 'Enabled',
    field: 'enabled'
  },
  {
    label: 'Parent Rec Area',
    field: 'recareas[0].name'
  },
  {
    label: '',
    field: ''
  },
  {
    label: 'Organization',
    field: 'organizations',
    arrayIdField: 'id',
    arrayFields: ['name']
  },
  {
    label: 'Activities',
    field: 'activities',
    arrayIdField: 'activityId',
    arrayFields: ['name']
  },
  {
    label: 'Description',
    fullWidth: true,
    field: 'description'
  },
  {
    label: 'Directions',
    fullWidth: true,
    field: 'directions'
  },
  {
    label: 'Keywords',
    fullWidth: true,
    field: 'keywords'
  },
  {
    label: 'Stay Limit',
    fullWidth: true,
    field: 'stayLimit'
  },
  {
    label: 'Addresses',
    fullWidth: true,
    field: 'addresses',
    arrayIdField: 'id',
    arrayFields: [
      'address1',
      'address2',
      'address3',
      'city',
      'stateCode',
      'postalCode',
      'countyCode'
    ]
  }
];

const recAreaDisplayFields = [
  {
    label: 'Rec Area Name',
    field: 'name'
  },
  {
    label: 'Rec Area ID',
    field: 'id'
  },
  {
    label: 'Email',
    field: 'email'
  },
  {
    label: 'Fee Description',
    field: 'feeDescription'
  },
  {
    label: 'Legacy ID',
    field: 'legacyId'
  },
  {
    label: 'Legacy ID Organization',
    field: 'legacyIdOrg'
  },
  {
    label: 'Latitude',
    field: 'latitude'
  },
  {
    label: 'Longitude',
    field: 'longitude'
  },
  {
    label: 'Phone',
    field: 'phone'
  },
  {
    label: 'Enabled',
    field: 'enabled'
  },
  {
    label: 'Parent Rec Area',
    field: 'parent'
  },
  {
    label: '',
    field: ''
  },
  {
    label: 'Organization',
    field: 'organizations',
    arrayIdField: 'id',
    arrayFields: ['name']
  },
  {
    label: 'Activities',
    field: 'activities',
    arrayIdField: 'activityId',
    arrayFields: ['name']
  },
  {
    label: 'Description',
    fullWidth: true,
    field: 'description'
  },
  {
    label: 'Directions',
    fullWidth: true,
    field: 'directions'
  },
  {
    label: 'Keywords',
    fullWidth: true,
    field: 'keywords'
  },
  {
    label: 'Stay Limit',
    fullWidth: true,
    field: 'stayLimit'
  },
  {
    label: 'Addresses',
    fullWidth: true,
    field: 'addresses',
    arrayIdField: 'id',
    arrayFields: [
      'address1',
      'address2',
      'address3',
      'city',
      'stateCode',
      'postalCode',
      'countyCode'
    ]
  }
];

export class StewardAssetDisplayPage extends PureComponent {
  componentDidMount() {
    this.fetchData(this.props.match.params.assetId);
  }

  assetNeedsUpdate(assetID) {
    return assetID && get(this.props.asset, 'id') !== assetID;
  }

  getButtons(assetType, assetId, reservable) {
    return (
      <div className={styles['display-buttons']}>
        <Link className="rec-button-tertiary" to={`/data-steward/${assetType}/search`}>Back to search</Link>
        {reservable
          ? <a className="rec-button-primary" href={`https://manage.${process.env.DOMAIN}`}>Edit in the Hub</a>
          : <Link className="rec-button-primary" to={`/data-steward/${assetType}/${assetId}/edit`}>Edit</Link>
        }
      </div>
    );
  }

  fetchData(assetID) {
    if (this.assetNeedsUpdate(assetID)) {
      this.props.fetchData(assetID, { full: true });
    }
  }

  render() {
    const { match: { params: { assetType, assetId } }, states: { asset } } = this.props;
    const displayFields = assetType === FACILITY_URL ? facilityDisplayFields : recAreaDisplayFields;

    const loading = asset !== STATE_READY;
    const buttons = this.getButtons(assetType, assetId, get(this.props.asset, 'reservable', true));

    return (
      <SkipNavContent>
        <main role="main" className={styles['steward-display']}>
          {buttons}
          <LoadingWrapper loading={loading} size="large">
            <div className={styles['display-body']}>
              {displayFields.map((displayField) => (
                <TextDisplay
                  key={displayField.field}
                  label={displayField.label}
                  field={displayField.field}
                  arrayFields={displayField.arrayFields}
                  arrayIdField={displayField.arrayIdField}
                  fullWidth={displayField.fullWidth}
                  value={get(this.props.asset, displayField.field, '')} />
              ))}
            </div>
          </LoadingWrapper>
          {buttons}
        </main>
      </SkipNavContent>
    );
  }
}

StewardAssetDisplayPage.propTypes = propTypes;
StewardAssetDisplayPage.defaultProps = defaultProps;

const mapStateToProps = (state) => ({
  asset: getAsset(state),
  states: getState(state, 'asset')
});

const mapDispatchToProps = (dispatch, ownProps) => {
  const fetchData = (id, query) => fetchAsset(ownProps.match.params.assetType, id, query);

  return bindActionCreators({ fetchData }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(StewardAssetDisplayPage);
